import React, { useEffect } from 'react';
import * as CONSTANTS from '../../utils/CONSTANTS';
import { makeSideBarActive } from '../../utils/EllowUtils';
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import { useState } from 'react';
import Styles from "./styles.module.scss";
import InContractTab from './inContractTab';
import ClosedFullTime from './fulltimeClosed';
import { getAllocatedto, getCandidates, getHistory, getHistoryFulltime, getCompany, getAllRecruiters, getProviderResources, getRecruiterResources } from './services';
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from "../../components/tab";
import {
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';
import { getAPI } from '../../api/api';
import { REACT_APP_COMMON } from '../../utils/common';



function InContract() {
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2)
  const BreadcrumsValues = ["In Contract"]

  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [filterValues, setFilterValues] = useState<any>(null)
  const [companyName, setCompanyName] = useState<any>()
  const [contractHistory, setContractHistory] = useState<any>()
  const [activeInContractData, setActiveInContractData] = useState<any>()
  const [closedInContractData, setClosedInContractData] = useState<any>()
  const [fulltimeClosedData, setFulltimeClosedData] = useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [incontractTotal, setIncontractTotal] = useState<any>()
  const [activeTotal, setActiveTotal] = useState<number>()
  const [closedTotal, setClosedTotal] = useState<number>()
  const [fulltimeClosedTotal, setFulltimeClosedTotal] = useState<number>()
  const [companyList, setCompanyList] = useState<any>();
  const [allRecruiters, setAllRecruiters] = useState<any>()
  const [skillList, setSkillList] = useState<any>()
  const [jobRoleList, setJobRoleList] = useState<any>()

  useEffect(() => {
    getAllResources( 25, 1, '')
    getAllocation();
    viewedpageMixpanel();
    getCompanyList();
    RecruiterList();
    
    getAPI( REACT_APP_COMMON + '/skills').then((resp: any) => {
      if (resp && resp.status === 1) {
        setSkillList(resp.data);
      }
    })

    getAPI( REACT_APP_COMMON + '/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })


  }, [])

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelectedTab(e.selected)   
  }

  const ActiveTab = <>Active<i>{activeTotal}</i></>
  const ClosedTab = <>Closed<i>{closedTotal}</i></>
  const FulltimeClosed = <>Fulltime<i>{fulltimeClosedTotal}</i></>
  
  const getAllocation = () => {
    getAllocatedto().then((response) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        );
      }
    });
  };

  const RecruiterList = () => {
    getAllRecruiters().then((response: any) => {
      if (response && response.status === 1) {
        setAllRecruiters(
          response.data.map((item: any) => {
            return item.name;
          })
        )
      }
    })
  }


  const getAllResources = ( pageSize: any, pageNumber: number, searchValue: string, filters?: any) => {  
    
    getCandidates('inContract', pageSize, pageNumber, searchValue, filters).then((response) => {
      if(response && response.status === 1){
        // if(response.data && response.data.length > 0){        
        //   getContractHistory(response.data[0].loginId)
        // }
        setActiveInContractData(response.data)
        setActiveTotal(response.count)
      }
    })
    getCandidates('inContractClosed', pageSize, pageNumber, searchValue, filters).then((response) => {
      if(response && response.status === 1){
        // if(response.data && response.data.length > 0){
        //   getContractHistory(response.data[0].loginId)
        // }
        setClosedInContractData(response.data)
        setClosedTotal(response.count)
      }
    })
    getCandidates('fullTimeJob', pageSize, pageNumber, searchValue, filters).then((response) => {
      if(response && response.status === 1){
        // if(response.data && response.data.length > 0){
        //   getContractHistory(response.data[0].loginId)
        // }
        setFulltimeClosedData(response.data)
        setFulltimeClosedTotal(response.count)
      }
    })
  }
  
  const searchChange = (e: string) => {
    getAllResources( 25, 1, e)
  }
  
  
  const closeTag = (data: any) => {
    let value = {
      filters: data
    }
      applyFilter(value);
    
  }

  const applyFilter = (data: any) => {
    setFilterValues(data.filters)
    getAllResources( 25, 1, '', data)
  }

  const pageChange = (pageSize: number, pageNumber: number) => {
    getAllResources( pageSize , pageNumber , '')
  }
  
  const getContractHistory = (candidateLoginId: string) => {
    getHistory(candidateLoginId).then((response) => {
      if (response && response.status === 1) {
        setContractHistory(response.data)
      }
    })
  }

  const getContractHistoryFulltime = (candidateLoginId: string) => {
    getHistoryFulltime(candidateLoginId).then((response: any) => {
      if (response && response.status === 1) {
        setContractHistory(response.data)
      }
    })
  }

  const getCompanyList = () => {
    getCompany().then((response) => {
      if (response && response.status === 1) {
        setCompanyList(response.data.map((item:any) => item.companyName));
      }
    });
  };

  

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} openresource={'incontract'} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          applyResourceFilter={applyFilter}
          searchChange={searchChange}
          closeTag={closeTag}
          navigateTo="../createResources"
          filterValues={filterValues}
          companyName={companyName}
          companyList={companyList}
          type='inContract'
          allocatedTo={allocatedTo}
          getRecruiterResources={getRecruiterResources}
          getProviderResources={getProviderResources}
          skillsList={skillList}
          jobRolesList={jobRoleList}
        />
      <section className={Styles.dashboardWrapper}>
        <TabStrip selected={selectedTab} onSelect={handleSelect}>
          <Tab title={ActiveTab}>
            <InContractTab data={activeInContractData} total={activeTotal} allocatedTo={allocatedTo} contractHistory={contractHistory} handlePageChange={pageChange} getTablesValues={() => getAllResources(25, 1, '')} onClick={getContractHistory} />
          </Tab> 
          <Tab title={ClosedTab}>
            <InContractTab data={closedInContractData} total={closedTotal} allocatedTo={allocatedTo} contractHistory={contractHistory} handlePageChange={pageChange} getTablesValues={() => getAllResources(25, 1, '')} onClick={getContractHistory} closed={true}/>
          </Tab> 
          <Tab title={FulltimeClosed}>
            <ClosedFullTime data={fulltimeClosedData} total={fulltimeClosedTotal} allocatedTo={allocatedTo} allRecruiters={allRecruiters} contractHistory={contractHistory} handlePageChange={pageChange} getTablesValues={() => getAllResources(25, 1, '')} onClick={getContractHistoryFulltime}/>
          </Tab> 
        </TabStrip>       
      </section>
      </div>
    </section>
  )
}

export default InContract